import { render, staticRenderFns } from "./AdvertsLists.vue?vue&type=template&id=d4944622&"
import script from "./AdvertsLists.vue?vue&type=script&lang=js&"
export * from "./AdvertsLists.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports